// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__mgFR_","bg-image":"styles_bg-image__cvJNF","bgImage":"styles_bg-image__cvJNF"};